
import {CustomClient4} from '../client'
import {TeamTypes, UserTypes} from 'mattermost-redux/action_types';
import {General} from 'mattermost-redux/constants';
import {forceLogoutIfNecessary, bindClientFunc} from 'mattermost-redux/actions/helpers';
import {batchActions} from 'redux-batched-actions';
import {logError} from 'mattermost-redux/actions/errors';

export function uploadTeamImage(teamId, imageData) {
    return async (dispatch, getState) => {

        dispatch({type: TeamTypes.UPDATE_TEAM_REQUEST}, getState);

        try {
            await CustomClient4.uploadTeamImage(teamId, imageData);
        } catch (error) {
            dispatch({type: TeamTypes.UPDATE_TEAM_FAILURE, error}, getState);
            return null;
        }

        dispatch({type: TeamTypes.UPDATE_TEAM_SUCCESS}, getState);

        return true;
    };
}

export function updateTeamPMR(team) {
    return async (dispatch, getState) => {

        dispatch({type: TeamTypes.UPDATE_TEAM_REQUEST}, getState);

        try {
            await CustomClient4.configPMR(team);
        } catch (error) {
            dispatch({type: TeamTypes.UPDATE_TEAM_FAILURE, error}, getState);
            return null;
        }

        dispatch({type: TeamTypes.UPDATE_TEAM_SUCCESS}, getState);

        return true;
    };
}

export function uploadTeamBackground(teamId, imageData) {
    return async (dispatch, getState) => {

        dispatch({type: TeamTypes.UPDATE_TEAM_REQUEST}, getState);

        try {
            await CustomClient4.uploadTeamBackgroundImage(teamId, imageData);
        } catch (error) {
            dispatch({type: TeamTypes.UPDATE_TEAM_FAILURE, error}, getState);
            return null;
        }

        dispatch({type: TeamTypes.UPDATE_TEAM_SUCCESS}, getState);

        return true;
    };
}

export function exportTeam(teamId) {
    return async (dispatch, getState) => {
        let fileName;
        try {
            fileName = await CustomClient4.exportTeam(teamId);
        } catch (error) {
            return null;
        }
        return fileName;
    };
}

export function getTeamStorage(teamId) {
    return async (dispatch, getState) => {
        let storage;
        try {
            storage = await CustomClient4.getTeamStorage(teamId);
        } catch (error) {
            return null;
        }
        return storage;
    };
}

export function getTeamVcHour(teamId) {
    return async (dispatch, getState) => {
        let vchour;
        try {
            vchour = await CustomClient4.getTeamVcHour(teamId);
        } catch (error) {
            return null;
        }
        return vchour;
    };
}

export function exportTeamDownload(teamId,fileId) {
    return async (dispatch, getState) => {
        let file;
        try {
            file = await CustomClient4.exportTeamDownload(teamId,fileId);
        } catch (error) {
            return null;
        }
        return file;
    };
}
export function getQuotation(teamId, enquiry) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getQuotation(teamId, enquiry);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function payByJetco(teamId, enquiry) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.payByJetco(teamId, enquiry);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function payByAlipay(teamId, enquiry) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.payByAlipay(teamId, enquiry);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function payByStripe(teamId, enquiry, token) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.payByStripe(teamId, enquiry, token);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function payZeroPayment(teamId, enquiry) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.payZeroPayment(teamId, enquiry);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function getContracts(teamId) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getContracts(teamId);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function getOrderHist(teamId) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getOrderHist(teamId);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function getInvoice(orderId) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getInvoice(orderId);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function getInvitesByEmail(email) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getInvitesByEmail(email);
        } catch (error) {
            return error;
        }
        return result;
    };
}
export function getInvitesByUserId() {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getInvitesByUserId();
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function getBillingAddress(teamId) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getBillingAddress(teamId);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function setBillingAddress(teamId, address) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.setBillingAddress(teamId, address);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function addGuestToTeam(teamId, userId) {
    return async (dispatch, getState) => {
        dispatch({type: TeamTypes.ADD_TEAM_MEMBER_REQUEST}, getState);

        let member;
        try {
            member = await CustomClient4.addGuestToTeam(teamId, userId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: TeamTypes.ADD_TEAM_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        dispatch(batchActions([
            {
                type: UserTypes.RECEIVED_PROFILE_IN_TEAM,
                data: {user_id: userId},
                id: teamId
            },
            {
                type: TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                data: member
            },
            {
                type: TeamTypes.ADD_TEAM_MEMBER_SUCCESS
            }
        ]), getState);

        return true;
    };
}

export function addAllUsersToTeam(teamId) {
    return async (dispatch, getState) => {
        dispatch({type: TeamTypes.ADD_TEAM_MEMBER_REQUEST}, getState);

        let members;
        try {
            members = await CustomClient4.addAllUsersToTeam(teamId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: TeamTypes.ADD_TEAM_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const profiles = [];
        members.forEach((m) => profiles.push({id: m.user_id}));

        dispatch(batchActions([
            {
                type: UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                data: profiles,
                id: teamId
            },
            {
                type: TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                data: members
            },
            {
                type: TeamTypes.ADD_TEAM_MEMBER_SUCCESS
            }
        ]), getState);

        return members;
    };
}


export function addGuestsToTeam(teamId, userIds) {
    return async (dispatch, getState) => {
        dispatch({type: TeamTypes.ADD_TEAM_MEMBER_REQUEST}, getState);

        let members;
        try {
            members = await CustomClient4.addGuestsToTeam(teamId, userIds);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: TeamTypes.ADD_TEAM_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const profiles = [];
        members.forEach((m) => profiles.push({id: m.user_id}));

        dispatch(batchActions([
            {
                type: UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                data: profiles,
                id: teamId
            },
            {
                type: TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                data: members
            },
            {
                type: TeamTypes.ADD_TEAM_MEMBER_SUCCESS
            }
        ]), getState);

        return members;
    };
}

export function addAllGuestsToTeam(teamId) {
    return async (dispatch, getState) => {
        dispatch({type: TeamTypes.ADD_TEAM_MEMBER_REQUEST}, getState);

        let members;
        try {
            members = await CustomClient4.addAllGuestsToTeam(teamId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: TeamTypes.ADD_TEAM_MEMBER_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const profiles = [];
        members.forEach((m) => profiles.push({id: m.user_id}));

        dispatch(batchActions([
            {
                type: UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                data: profiles,
                id: teamId
            },
            {
                type: TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                data: members
            },
            {
                type: TeamTypes.ADD_TEAM_MEMBER_SUCCESS
            }
        ]), getState);

        return members;
    };
}

export function sendEmailInvitesGuestsToTeam(teamId, emails) {
    return bindClientFunc(
        CustomClient4.sendEmailInvitesGuestsToTeam,
        TeamTypes.TEAM_EMAIL_INVITE_REQUEST,
        [TeamTypes.TEAM_EMAIL_INVITE_SUCCESS],
        TeamTypes.TEAM_EMAIL_INVITE_FAILURE,
        teamId,
        emails
    );
}

export function getTeamsWithMemberCount(page = 0, perPage = General.TEAMS_CHUNK_SIZE, needCount = false) {
    return bindClientFunc(
        CustomClient4.getTeamsWithMemberCount,
        TeamTypes.GET_TEAMS_REQUEST,
        [TeamTypes.RECEIVED_TEAMS_LIST, TeamTypes.GET_TEAMS_SUCCESS],
        TeamTypes.GET_TEAMS_FAILURE,
        page,
        perPage,
        needCount
    );
}

export function getTeamsStats(teamIds) {

    return async (dispatch, getState) => {

        let statsList = null;
        try {
            statsList = await CustomClient4.getTeamsStats(teamIds);
        } catch (err) {
            forceLogoutIfNecessary(err, dispatch);
            return null;
        }

        const actions = [];

        statsList.forEach( stat => {
            actions.push(
                {type: TeamTypes.RECEIVED_TEAM_STATS, data: stat}
            )
        });
        dispatch(batchActions(actions), getState);

        return statsList;
    };

}


// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux actions/teams)
export function deleteTeam(teamId) {
    return async (dispatch, getState) => {
        try {
            await CustomClient4.deleteTeam(teamId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([logError(error)(dispatch)]), getState);
            return null;
        }

        return true;
    };
}

export function getTeamAdminUsers(teamId) {
    return async (dispatch, getState) => {
        let admins;
        try {
            admins = await CustomClient4.getTeamAdminUsers(teamId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([logError(error)(dispatch)]), getState);
            return null;
        }

        return admins;
    };
}

// ---

export default {
    uploadTeamImage,
    exportTeam,
    deleteTeam,
    getTeamAdminUsers
};


// WEBPACK FOOTER //
// ./custom-redux/actions/teams.jsx